export default "__VITE_ASSET__C5d7pVFF__"